import * as React from 'react'

import { IChild } from 'main/gql/child'
import ChildCard, { SelectorType } from './ChildCard'
import ChildForm from './ChildForm'
import { IChildEditState } from './types'

interface IProps {
  child: IChild | null
  editState: IChildEditState | null
  selected: boolean
  selectorType: SelectorType
  onChangeEditState: (editState: IChildEditState | null) => void
  onChangeSelected?: (selected: boolean) => void
  onComplete?: (child: IChild) => void
}

export default function ChildSection(props: IProps) {
  const {
    child,
    editState,
    selected,
    selectorType,
    onChangeEditState,
    onChangeSelected,
    onComplete,
  } = props

  return (
    <div>
      {child && !editState && (
        <ChildCard
          child={child}
          selected={selected}
          selectorType={selectorType}
          onChangeSelected={onChangeSelected || (() => undefined)}
          onEdit={() => onChangeEditState({ childId: child.id })}
        />
      )}

      {editState && (
        <ChildForm
          child={child}
          validationHints={editState.validationHints || {}}
          onChangeValidationHints={validationHints =>
            onChangeEditState({ ...editState, validationHints })
          }
          onComplete={childOnComplete => {
            if (onChangeSelected) {
              onChangeSelected(true)
            }

            if (onComplete) {
              onComplete(childOnComplete)
            }

            onChangeEditState(null)
          }}
        />
      )}
    </div>
  )
}
